import React from "react";
import Logo from "../img/logo.png";
import { Link } from "react-router-dom";
import Webimagefooter from "./Webimagefooter";

const Footer = () => {
  return (
    <div className=" w-full grid  md:mt-[-40px] mt-[-50px] place-items-center  bg-[linear-gradient(180deg,_#07031C_0%,_#000000_100%)]" >
    <div className=" md:w-full  pr-6 md:pl-20 pl-6 pt-10 pb-32 md: justify-center items-center md:py-20 flex flex-col md:flex-row gap-6">
<div className="w-full md:">
  {/* Center logo on mobile, align left on desktop */}
  <div className="flex justify-center md:justify-start pb-4">
    <img src={Logo} alt="logo" className="h-10" />
  </div>

  {/* Keep text left-aligned on all screens */}
  <h2 className="text-white text-lg mt-4 md:mt-10">
    Grow Your Portfolio, Secure Your Future
  </h2>
  <p className="text-sm text-white mt-4">
    Capital Nest Investments stands out as a premier choice for investors looking to grow their wealth through a reliable and forward-thinking platform. 
  </p>
</div>

<div className=" w-full md:px-0 pl-8 md:flex grid md:grid-cols-1 grid-cols-2 place-content-center  place-items-center bg"> 



      <div className="w-full md:w-[25%] md:block hidden">
        <h2 className="text-white text-lg mt-10 font-bold">Account</h2>
        <div className="mt-4 grid gap-4">
          <Link to="/signup" className="text-sm text-gray-300">Signup</Link>
          <Link to="/login" className="text-sm text-gray-300">Login</Link>
        </div>
      </div>

      <div className="w-full md:w-[25%]">
        <h2 className="text-white md:text-lg mt-10 font-bold  text-[20px]">Community</h2>
        <div className="mt-4 grid gap-4">
          <Link to="/" className="md:text-sm text-gray-300 text-[16px]">Home</Link>
          <Link to="/privacy" className="md:text-sm text-gray-300 text-[16px]" >Privacy</Link>
        </div>
      </div>

      <div className="w-full md:w-[25%]">
        <h2 className="text-white md:text-lg text-[20px] mt-10 font-bold">Contact</h2>
        <div className="mt-4 grid gap-4">
          <Link to="/aboutus" className="md:text-sm text-gray-300 font-normal text-[16px] ">About Us</Link>
          <Link to="/contactus" className="md:text-sm text-gray-300  font-normal text-[16px]">Contact Us</Link>
        </div>
      </div>

      </div>
  
  </div>
       <Webimagefooter/>
    </div>
   
        
  );
};

export default Footer;
